import React, { useState } from 'react';
import FeedbackLogo from '../assets/img/nove-logo.png';
import Header from './Header.js';
import Stickyheader from './Stickyheader.js';
// import ThankyouLogo from '../assets/img/haikuthankyou-logo.png';
import axios from 'axios';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

const Feedback = () => {
  const [selectedDate, setSelectedDate] = useState(null);
  const [formData, setFormData] = useState({
    branch:'',
    name: '',
    email: '',
    phone: '',
    visitus: '',
    discovery: '',
    experienceRating: '',
    foodQuality: '',
    serviceQuality: '',
    atmosphere: '',
    favoriteDish: '',
    improvement: '',
    recommend: '',
    comments: '',
  });

  const formatDate = (date) => {
    return date
      ? date.toLocaleString('en-US', {
          month: 'short',
          day: 'numeric',
          year: 'numeric',
          hour: 'numeric',
          minute: 'numeric',
          hour12: true,
        })
      : '';
  };

  const handleDateChange = (date) => {
    setSelectedDate(date);
    setFormData({
      ...formData,
      visitus: date,  // Updating the visitus field in formData
    });
  };
  

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    try {
      
      const formattedDate = formatDate(formData.visitus);

      const formDataObj = new FormData();
      Object.keys(formData).forEach(key => {
        formDataObj.append(key, key === 'visitus' ? formattedDate : formData[key]);
      });

      const response = await axios.post('https://api.novetheitaliankitchen.in/index.php/Api/addfeedback', formDataObj, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      console.log('Form submitted:', response.data);
      alert('Thank You for Your Feedback.');
      window.location.href="https://novetheitaliankitchen.com";
      // Reset form data after successful submission
      setFormData({
        branch:'',
        name: '',
        email: '',
        phone: '',
        visitus: '',
        discovery: '',
        experienceRating: '',
        foodQuality: '',
        serviceQuality: '',
        atmosphere: '',
        favoriteDish: '',
        improvement: '',
        recommend: '',
        comments: '',
      });

     setSelectedDate(null); // Reset the DatePicker

    } catch (error) {
      console.error('Error submitting feedback:', error);
    }
  };

  return (
    <>
      <Header />
      <Stickyheader />
      <div className="container-fluid feedback-fluid">
        <div className="container">
          <div className="feedback-form-cont">
            <div className="flex-cont">
              <div className="left-feedback-cont">
                {/* <div className="logo-img">
                  <img src={FeedbackLogo} alt="site-logo" />
                </div>
                */}

                <form onSubmit={handleSubmit}>
                  <div className="feedback-form">
                    <div className="form-group top-fields">
                    <label>Location <span className="text-danger">*</span></label>
                     <select
                        className="form-select form-control"
                        name="branch"
                        required
                        onChange={handleInputChange}
                        style={{marginBottom:'10px'}}
                        value={formData.branch}
                      >
                        <option value="">--Select Location--</option>
                          <option value="Banjara Hills" key="Banjara Hills">Banjara Hills</option>
                          <option value="Kokapet" key="Gachibowli">Kokapet</option>
                      </select>
                      <label>Name <span className="text-danger">*</span></label>
                      <input
                        type="text"
                        className="form-control"
                        name="name"
                        value={formData.name}
                        onChange={handleInputChange}
                        required
                      />
                      <label>Phone No</label>
                      <input
                        type="tel"
                        className="form-control"
                        name="phone"
                        value={formData.phone}
                        onChange={handleInputChange}
                      />
                      <label>Email </label>
                      <input
                        type="email"
                        className="form-control"
                        name="email"
                        value={formData.email}
                        onChange={handleInputChange}
                      />
                    </div>

                    <div className="form-group">
                      <label>When Did You Visit Us?</label><br></br>
                      <DatePicker
                        selected={selectedDate}
                        onChange={handleDateChange}
                        showTimeSelect
                        dateFormat="Pp"  // Display date and time (default format is MM/DD/YYYY, hh:mm AM/PM)
                        timeIntervals={15}  // Allows time to be selected in 15-minute increments
                        placeholderText="Date and Time"
                        className="form-control"

                      />
                      {/* <input
                        type="text"
                        className="form-control"
                        name="visitus"
                        value={formData.visitus}
                        onChange={handleInputChange}
                      /> */}
                    </div>
                    <div className="form-group">
                      <h3>How Did You Hear about Us?</h3>
                      {["A Friend's Pasta Fable", 'Social Media Shenanigans', 'Online Treasure Hunt', 'other'].map(option => (
                 
                         <div className="d-flex" key={option}>
                         <input
                           type="radio"
                           id={`discovery-${option}`}
                           name="discovery"
                           value={option}
                           onChange={handleInputChange}
                         />
                         <label htmlFor={`discovery-${option}`}>{option}</label>
                       </div>
                      ))}
                    </div>

                    <div className="form-group">
                    <h3>Rate Your Experience! <br></br>
                    (1 = Mama Mia!” to 5 = “Bellissimo”)</h3>
                      {['Oh No, My Taste Buds!', 'Just Okay, Like Cold Rice', 'Good, but Not a Knockout', 'Tasty! Like a Warm Bowl of Noodles', 'Spicy Perfection! I’ll Be Back!'].map(rate => (
                        <div className="d-flex" key={rate}>
                          <input
                            type="radio"
                            id={`experience-${rate}`}
                            name="experienceRating"
                            value={rate}
                            onChange={handleInputChange}
                          />
                          <label htmlFor={`experience-${rate}`}>{rate}</label>
                        </div>
                      ))}
                    </div>
                    <div className="form-group">
                      <h3>Food Quality:</h3>
                      {['Who Spilled the Tomato Sauce?', 'Just Okay', 'Good Enough for Nonna', 'Yummy!', 'Worthy of the Olive Garden!'].map(rate => (
                        <div className="d-flex" key={rate}>
                          <input
                            type="radio"
                            id={`foodQuality-${rate}`}
                            name="foodQuality"
                            value={rate}
                            onChange={handleInputChange}
                          />
                          <label htmlFor={`foodQuality-${rate}`}>{rate}</label>
                        </div>
                      ))}
                    </div>

                    <div className="form-group">
                      <h3>Service Quality:</h3>
                      {['Lost in Translation', 'Could Use Some Spice', 'On the Right Track', 'Fast as a Ferrari!', 'Service with a Smile (and a Side of Garlic Bread!)'].map(rate => (
                        <div className="d-flex" key={rate}>
                          <input
                            type="radio"
                            id={`serviceQuality-${rate}`}
                            name="serviceQuality"
                            value={rate}
                            onChange={handleInputChange}
                          />
                          <label htmlFor={`serviceQuality-${rate}`}>{rate}</label>
                        </div>
                      ))}
                    </div>

                    <div className="form-group">
                      <h3>Atmosphere & Ambiance:</h3>
                      {['More Like a Fast-Food Joint', 'Could Use Some Olive Oil', ' Cozy, Like a Warm Focaccia', 'Perfect for a Date with a Pizza', 'Feels Like Italy!'].map(rate => (
                        <div className="d-flex" key={rate}>
                          <input
                            type="radio"
                            id={`atmosphere-${rate}`}
                            name="atmosphere"
                            value={rate}
                            onChange={handleInputChange}
                          />
                          <label htmlFor={`atmosphere-${rate}`}>{rate}</label>
                        </div>
                      ))}
                    </div>
                    {/* Repeat similar structure for food quality, service quality, and atmosphere */}
                    
                    <div className="form-group">
                      <label>What Was Your Favorite Dish?</label>
                      <input
                        type="text"
                        className="form-control"
                        name="favoriteDish"
                        value={formData.favoriteDish}
                        onChange={handleInputChange}
                      />
                    </div>

                    <div className="form-group">
                      <label>What Would You Improve?</label>
                      <input
                        type="text"
                        className="form-control"
                        name="improvement"
                        value={formData.improvement}
                        onChange={handleInputChange}
                      />
                    </div>

                    <div className="form-group">
                      <h3>Would You Recommend Us?</h3>
                      {['Yes, I’ll Shout It from the Rooftops!', 'No, I’d Rather Eat Spaghetti with a Spoon.'].map(option => (
                        <div className="d-flex" key={option}>
                          <input
                            type="radio"
                            id={option}
                            name="recommend"
                            value={option}
                            onChange={handleInputChange}
                          />
                          <label htmlFor={option}>{option.charAt(0).toUpperCase() + option.slice(1)}</label>
                        </div>
                      ))}
                    </div>

                    <div className="form-group">
                      <label>Any Additional Comments or Fun Stories to Share?</label>
                      <input
                        type="text"
                        className="form-control"
                        name="comments"
                        value={formData.comments}
                        onChange={handleInputChange}
                      />
                    </div>

                    <button type="submit" className="submit-feedback">
                      Submit
                    </button>
                  </div>
                </form>

                <div className="thankyou-cont">
                  <h4>🌟 Thank You for Your Feedback!<br></br> We Can’t Wait to Serve You Again! 🌟</h4>
                  
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Feedback;
